export default {
    pregnancyMethod: 'Pregnancy Method',
    pregnancyMethodTitle: 'Title',
    pregnancyMethodStatus: 'Status',
    pregnancyMethods: 'Pregnancy Methods',
    editPregnancyMethod: 'Edit Pregnancy Method',
    addPregnancyMethod: 'Add Pregnancy Method',
}